import { gql } from "@apollo/client"

export const GAME_LIST = gql`
  query GameList($GameListInput: GameListInput!) {
    GameList(input: $GameListInput) {
      status {
        success
        name
        detail
      }
      Games {
        id
        name
        availables
      }
    }
  }
`
